module.exports = __webpack_public_path__ + "img/26_6.d9c98cee.png";